// ── Circular countdown timer ──────────────────────────────────────────────────
// Props: timeLeft, maxTime (default 60), tv

export default function CircleTimer({ timeLeft, maxTime = 60, tv }) {
  const size = tv ? 200 : 140;
  const r = (size - 18) / 2;
  const circ = 2 * Math.PI * r;
  const pct = Math.max(0, timeLeft / maxTime);
  const color = timeLeft > maxTime * 0.5 ? "#3DFF3D" : timeLeft > maxTime * 0.2 ? "#FFE000" : "#FF3355";

  return (
    <div style={{ position: "relative", width: size, height: size, margin: "0 auto" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}
        style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#111" strokeWidth="12" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="10"
          strokeDasharray={circ} strokeDashoffset={circ * (1 - pct)} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.9s linear,stroke 0.3s" }} />
      </svg>
      <div style={{
        position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Rubik Mono One',monospace", fontSize: tv ? "4rem" : "2.75rem",
        color, textShadow: "3px 3px 0 #000",
        animation: timeLeft <= 10 && timeLeft > 0 ? "wiggle 0.4s ease-in-out infinite" : "none",
      }}>
        {timeLeft}
      </div>
    </div>
  );
}
